import { HttpErrorResponse } from '@angular/common/http';

export interface ApiConstant {
    endpoint: string;
    socketServer: string;
}
export interface CustomHttpErrorResponse extends HttpErrorResponse {
    errorJson?: any;
}

export interface PaginateOptions {
    pageIndex: number;
    pageSize: number;
    filter?: string;
}

export enum FEEDBACK_TYPE {
    LIKE = 1,
    QUESTION = 2,
    ALERT = 3
}
